import Component from "../abstracts/Component";
import Observer from "../utils/Observer";
import 'gsap';

/**
 * For each element having the "observe" class, the "inViewport" class will be added on enter in viewport
 * @see _u_on-enter-in-viewport.scss
 */
export default class OnEnterInViewportComponent extends Component {

  get SELECTORS() {
    return {
      container: '.js-observe-on-enter-viewport',
      observe: '.observe'
    }
  }

  get CONF() {
    return {
      margin: 200
    }
  }

  get CLASSES() {
    return {
      inViewport: 'in-viewport'
    }
  }

  constructor() {
    super()
  }

  animateLetters(el) {
    var Jletters = el.find('.letter').toArray();
    TweenMax.set(Jletters, {
      autoAlpha: 0
    });
    Jletters.sort(function () {
      return 0.5 - Math.random()
    });
    let timeToStagger = Jletters.length > 100 ? 0.007 : 0.035;
    TweenMax.staggerTo(Jletters, 0.6, {
      autoAlpha: 1,
      ease: Quad.easeInOut
    }, timeToStagger);
  }

  addClass(el) {
    el.classList.add(this.CLASSES.inViewport);
  }

  addClassZoom(el) {
    this.addClass(el);
    setTimeout(() => {
      if (el.classList.contains('c-category-push')) {
        $(el).find('.zoom-on-enter-in-viewport').addClass('is-complete-category-push');
      } else {
        $(el).find('.zoom-on-enter-in-viewport').addClass('is-complete');
      }
    }, 2100);
  }

  bindScroll() {

    new Observer(this.SELECTORS.container, this.CONF.margin, null, (entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {

          if (entry.target.classList.contains('wrapper-quote') && !entry.target.classList.contains(this.CLASSES.inViewport)) {

            let $wrapper = $(entry.target);
            this.animateLetters($wrapper);
            if ($wrapper.next().length) {
              this.animateLetters($wrapper.next());
            }
            this.addClass(entry.target);

          }

          // animazioni disabilitate su mobile
          if (window.innerWidth > 768) {
            if ((entry.target.classList.contains('c-category-push') || entry.target.classList.contains('c-product-push')) && !entry.target.classList.contains(this.CLASSES.inViewport)) {
              let $selector = $(entry.target);
              let slideToAnimate = null;
              if (this.$matchMedia(null, 'lg')) {
                slideToAnimate = $selector.find('.slick-initialized .slick-slide.slick-active');
              } else {
                let slides = $selector.find('.slick-initialized .slick-slide');
                slideToAnimate = slides.slice(0, 6);
              }
              let tl = new TimelineLite();
              tl.staggerFrom(slideToAnimate, 1.5, {
                x: "50%",
                opacity: 0,
                ease: Power2.easeOut,
                onComplete: this.addClassZoom(entry.target)
              }, 0.3);

            } else if (entry.target.classList.contains('translateY-on-enter-in-viewport')) {
              this.addClass(entry.target);
              setTimeout(() => {
                $(entry.target).find('.zoom-on-enter-in-viewport').addClass('is-complete');
              }, 1500);
            } else if (entry.target.classList.contains('wrapper-carousel') && !entry.target.classList.contains(this.CLASSES.inViewport)) {

              let $selector = $(entry.target);
              let carouselToAnimate = $selector.find('.carousel.slick-initialized');
              if(carouselToAnimate.length){
                let tl = new TimelineLite();
                tl.staggerFrom(carouselToAnimate, 1.4, {
                  x: "-60%",
                  opacity: 0,
                  ease: Power2.easeOut,
                  onComplete: this.addClassZoom(entry.target)
                }, .4);
              }

            } else {
              this.addClass(entry.target);
            }
          }

        }

      });
    });
  }

  render() {
    if (document.querySelector(this.SELECTORS.container)) this.bindScroll();
  }
}
